import Rate from 'antd/lib/rate'

import 'antd/lib/rate/style'

export * from 'antd/lib/rate'

export default Rate
